import LatestActivity from "./latest-activity";

export default LatestActivity;